import { capitalize } from '@gonfalon/strings/capitalize';

import { successCriteriaDisplayOptions } from './constants';
import type { Metric } from './types';

export function getSuccessCriteriaDisplayName(successCriteria: Metric['successCriteria']): string {
  const option = successCriteriaDisplayOptions().find((sc) => sc.value === successCriteria);
  return option ? capitalize(option.displayName) : 'undefined';
}
